"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonPadOk = void 0;
const react_1 = __importStar(require("react"));
const ButtonPadOk = ({ x, y, width, height, onPressIn, onPressOut, color, backgroundColor }) => {
    const [isTouching, setIsTouching] = (0, react_1.useState)(false);
    const pressIn = () => {
        if (onPressIn) {
            onPressIn();
        }
        setIsTouching(true);
    };
    const pressOut = () => {
        if (onPressOut) {
            onPressOut();
        }
        setIsTouching(false);
    };
    return (react_1.default.createElement("svg", { x: x, y: y, width: width, height: height, onTouchStart: pressIn, onTouchEnd: pressOut, viewBox: "0 0 76 76", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { fill: backgroundColor, cx: "38", cy: "38", r: "38" }),
        react_1.default.createElement("circle", { fill: "rgba(255,255,255,0.1)", cx: "38", cy: "38", r: "38" }),
        isTouching &&
            react_1.default.createElement("circle", { fill: "rgba(255,255,255,0.2)", cx: "38", cy: "38", r: "38" }),
        react_1.default.createElement("path", { fill: color, d: "M30 23V53L54 38L30 23Z" })));
};
exports.ButtonPadOk = ButtonPadOk;
//# sourceMappingURL=ok.js.map